import GroupRestrictions from "./GroupsRestrictionsLayout";
export default GroupRestrictions;
